import { render, staticRenderFns } from "./pendingOrdersTable.vue?vue&type=template&id=37b4399c&scoped=true&"
import script from "./pendingOrdersTable.vue?vue&type=script&lang=js&"
export * from "./pendingOrdersTable.vue?vue&type=script&lang=js&"
import style0 from "./pendingOrdersTable.vue?vue&type=style&index=0&id=37b4399c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b4399c",
  null
  
)

export default component.exports